export const Pagecontrol = (page) => ({
  type: "thepage",
  page,
});
